import { combineReducers } from "redux";

import { rootKey as service, reducer as serviceReducer } from "./service";

export const rootReducer = combineReducers({
  [service]: serviceReducer,
});
